import AuditLogsTable from "./components/AuditLogs";
import { useEffect, useState, useContext, useRef } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import { getAuditLogs } from "api/users";
import { getAllUsersList } from "api/graphQL_users";
import moment from "moment";

export interface LogsRowObj {
    id: any;
    user_id: any;
    module: any;
    description: any;
    ip_address: any;
    user_agent : any;
    created_at : any;
    updated_at : any;
    user_name : any;
}

const AuditLogs = () => {

    const [page, setPage] = useState<number>(1);
    const [logs, setLogs] = useState<LogsRowObj[]>([]);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { singleRoleData, setSingleRoleData  } = useContext(ClientContext);
    const [filter, setFilter] = useState({
        dates: null,
        users : ""
    });
    const location = useLocation();
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked,setClearClick] = useState(0)
    const [users, setUsers] = useState();
    const onClearClick = () => {
        setPage(1);
        setPageSize(50);
        setClearClick((prev) => {
          const newCount = prev + 1;
          return newCount;
        });
    };

    useEffect(() => {
      setPage(1);
      setPageSize(50);
    }, [searchTexts]);

    const fetchLogs = async () => {
        let finalSearchText = ""
        if(location.state) {
            if (location.state?.search) {
            finalSearchText = location.state.search
            window.history.replaceState({}, document.title);
            }
        } else {
            finalSearchText = searchTexts;
        }
        const start_date = filter?.dates?.[0];
        const end_date = filter?.dates?.[1];
        
        if (pageSize === null || pageSize === undefined) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);

        let date_range = ""
        if(start_date && end_date) {
            date_range = moment(start_date).format("YYYY-MM-DD") + " to " + moment(end_date).format("YYYY-MM-DD")
        }

        console.log("date_range",filter)
        console.log("date_range",date_range)
        const params = { 
            page: page, 
            per_page: pageSize, 
            searchTexts: finalSearchText.trim(),
            start_date:start_date,
            end_date : end_date,
            user_id : filter?.users || "",
            date_range : date_range
        };

        getAuditLogs(params)
        .then((data:any) => {
            setLogs(data?.user_logs);
            setTotalPage(data?.total_pages);
            setTotalItems(data?.total_records);
            setCurrentPage(data?.page);
        })
        .catch((err) => {
            setLogs([]);
            setIsLoading(false);
        })
        .finally(() => {
        setIsLoading(false);
        });
    };

    const serchboxValueChange = async (searchTerm: string) => {
        const search_txt = searchTerm || "";
    
        if (search_txt !== searchTexts && searchTexts !== "") {
          await setSearchTexts(search_txt);
          setPage(1);
          setCurrentPage(1);
        } else {
          await setSearchTexts(search_txt);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [page, pageSize, searchTexts,clearClicked]);

    useEffect(() => {
        fetchUsers();
        setFilter({
            dates: null,
            users : ""
        });
    }, []);

    const fetchUsers = () => {
        setIsLoading(true);
        const params = { page: 1, per_page: 5000, searchTexts: "" };
        getAllUsersList(params)
        .then((data) => {
            setUsers(data.users);
        })
        .catch((err) => {
            toast.error(
                err?.response?.data?.message ??
                "Something went wrong while fetching clients"
            );
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    
    return (
        <>
            <div className="mt-5">
                <AuditLogsTable 
                    users={users}
                    tableData={logs}
                    fetchLogs={fetchLogs}
                    isLoading={isLoading}
                    roleData={singleRoleData}
                    onValueChange={serchboxValueChange}
                    page={page}
                    setPage={setPage}
                    totalpage={totalpage}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setLocalFilters={setLocalFilters}
                    filterData={fetchLogs}
                    localFilters={localFilters}
                    filter={filter}
                    setFilter={setFilter}
                    setClearClick={onClearClick}
                />

            </div>
        </>
    );
};

export default AuditLogs;
